import React from 'react';
import { Triangle, Ruler, Zap, Gauge, SlidersHorizontal, Cable } from 'lucide-react';
import { configurationFields, configurationLabel } from '../../lib/product-configurations';

const colour = value => {
  const text = String(value).toLowerCase();
  if (text.includes('black')) return '#292929';
  if (text.includes('white')) return '#fff';
  if (text.includes('gold')) return '#b89d63';
  if (text.includes('silver') || text.includes('chrome')) return '#bac0c2';
  return '#999';
};
const swatch = (key, value) => {
  if (key === 'body_finish') {
    const parts = String(value).split('+');
    return parts.length > 1 ? `linear-gradient(90deg,${colour(parts[0])} 50%,${colour(parts[1])} 50%)` : colour(value);
  }
  if (key === 'color_temperature') {
    if (/switch|tunable|\//i.test(value)) return 'linear-gradient(90deg,#ffdb9f,#d5ebff)';
    const kelvin = parseInt(value,10);
    return kelvin < 3500 ? '#ffdb9f' : kelvin < 4500 ? '#f5f1e5' : '#d5ebff';
  }
  return null;
};
const optionIcons = {beam_angle: Triangle, dimension: Ruler, length: Ruler, wattage: Zap, cri: Gauge, dimming: SlidersHorizontal, driver: Cable};
export const ConfigurationOptions = ({rows, selected, onChoose}) => <div className="grid grid-cols-1 min-[360px]:grid-cols-2 gap-x-4 gap-y-3 content-start" data-testid="configuration-options">
  {configurationFields.filter(k => rows.some(r => r[k])).map(key => {
    const values = [...new Set(rows.map(r => r[key]).filter(Boolean))];
    const colourValue = swatch(key, selected?.[key] || '');
    const Icon = optionIcons[key];
    return <div key={key} className="min-w-0">
      <label htmlFor={`configure-${key}`} className="text-xs font-medium text-neutral-600 flex items-center gap-2 mb-1.5">
        {colourValue && <span data-testid={`config-${key}-indicator`} aria-hidden="true" className="w-3.5 h-3.5 shrink-0 rounded-full border border-neutral-300" style={{background: colourValue}} />}
        {Icon && <Icon data-testid={`config-${key}-indicator`} aria-hidden="true" className="w-3.5 h-3.5 shrink-0" />}
        {configurationLabel(key)}
      </label>
      <div className="min-w-0">
        <select id={`configure-${key}`} data-testid={`config-${key}`} title={selected?.[key] || configurationLabel(key)} className="w-full min-w-0 h-10 border border-neutral-300 rounded px-2 bg-white text-xs focus-visible:outline-2 focus-visible:outline-black" value={selected?.[key] || ''} onChange={e => onChoose(key,e.target.value)}>
          {!selected?.[key] && <option data-testid={`config-${key}-unrecorded`} value="">Not recorded for this configuration</option>}
          {values.map((v,i) => <option data-testid={`config-${key}-option-${i}`} key={v} value={v}>{v}</option>)}
        </select>
      </div>
    </div>;
  })}
</div>;